export interface messageData {
  messageKey: string | undefined;
  replacementParams?: object;
}

/**
 * messageData型かどうかを返す
 * @param item 判定対象の値
 * @returns messageDataの型判定結果
 * Booleanを返却した場合、返却先で再度typeofを行わないと、コンパイルエラーになってしまう。
 * ⇒そのため、item is messageDataとすることで、BooleanかつmessageData型ということを明示的にする
 * 参考：https://typescript-jp.gitbook.io/deep-dive/type-system/typeguard#yznotype-guard
 */
export function isMessageData(item: any): item is messageData {
  return (
    typeof item == 'object' &&
    typeof item.messageKey == 'string' &&
    (item.replacementParams == null ||
      typeof item.replacementParams == 'object')
  );
}
